import { useEffect, useState } from 'react';

import { getCurrentDateTime } from 'features/common/network/domain/network.helper';
import {
  subscribeNetworkError,
  subscribeNetworkSuccess,
} from '../../../domain';
import { logNetworkError } from '../../../infra/analytics';

export function useOfflineBanner() {
  const [isOffline, setIsOffline] = useState(false);
  const [offlineDateTime, setOfflineDateTime] = useState<string>('');

  useEffect(() => {
    const handleNetworkError = () => {
      setIsOffline(true);
      setOfflineDateTime(getCurrentDateTime());
    };

    const handleNetworkSuccess = () => {
      let wasOffline = false;

      setIsOffline(prevIsOffline => {
        wasOffline = prevIsOffline;
        return false;
      });

      if (wasOffline && offlineDateTime) {
        logNetworkError(offlineDateTime).catch(error => {
          console.warn('Error tracking network error:', error);
        });
      }
    };

    const cleanupError = subscribeNetworkError(handleNetworkError);
    const cleanupSuccess = subscribeNetworkSuccess(handleNetworkSuccess);

    return () => {
      cleanupError();
      cleanupSuccess();
    };
  }, [offlineDateTime]);

  return {
    isOffline,
  };
}
